import Splide from "@splidejs/splide";

function initializeCaseStudyOverview() {
  // Inizialize slider for the category navigation
  const categoryNavigation = document.querySelectorAll(
    ".casestudies__navigation"
  );
  // Exit function if no category navigation is found
  if (!categoryNavigation) {
    return;
  }
  // Initialize Splide for each category navigation
  categoryNavigation.forEach((navigation) => {
    new Splide(navigation, {
      autoWidth: true,
      gap: "1.5rem",
      arrows: false,
      pagination: false,
      isNavigation: true,
    }).mount();
  });

  // Hold the current category
  let currentCategory = 0;

  // Get navigation elements
  const navItems = document.querySelectorAll(".casestudies__navigation-item");
  // Exit if no navigation items are found
  if (!navItems) {
    return;
  }
  // Get case study elements
  const caseStudies = document.querySelectorAll(".casestudies__case");
  // Exit if no case studies are found
  if (!caseStudies) {
    return;
  }

  // Hold each case study in an array for later use when filtering
  const caseStudiesArray = Array.from(caseStudies);
  // Get the container element for the case studies
  const caseStudiesContainer = document.querySelector(".casestudies__cases");

  // Loop through navigation items
  navItems.forEach((navItem) => {
    // Add click event listener
    navItem.addEventListener("click", (event) => {
      // Get the data attribute of the clicked navigation item
      const clickedNavItem = event.target.dataset.casestudies;
      // Skip if no data attribute is found or data attribute is euqal to current category
      if (!clickedNavItem || clickedNavItem === currentCategory) {
        return;
      }
      // Remove all child elements from the case studies container
      while (caseStudiesContainer.firstChild) {
        caseStudiesContainer.removeChild(caseStudiesContainer.firstChild);
      }
      // Add the case studies to the container
      addCaseStudiesForCategory(clickedNavItem);
    });
  });

  function addCaseStudiesForCategory(category) {
    // Update the category and navigation item
    updateCategory(category);
    // Hold filtered case studies in an array
    const filteredCaseStudies = [];
    // If the category is 0, show all case studies
    if (category === "0") {
      caseStudiesArray.forEach((caseStudy) => {
        // Push the case study to the filtered case studies array
        filteredCaseStudies.push(caseStudy);
      });
    }
    // If the category is not 0, show only case studies with the same category
    caseStudiesArray.forEach((caseStudy) => {
      if (compareCategory(caseStudy, category)) {
        // Push the case study to the filtered case studies array
        filteredCaseStudies.push(caseStudy);
      }
    });
    // Loop through filtered case studies
    filteredCaseStudies.forEach((caseStudy) => {
      // Add the case study to the case studies container
      caseStudiesContainer.appendChild(caseStudy);
    });
    checkContainerPadding(filteredCaseStudies.length);
  }

  function updateCategory(category) {
    // Update the current category
    currentCategory = category;
    // Remove the active class from all inactive navigation items and set the active class on the clicked navigation item
    navItems.forEach((navItem) => {
      if (navItem.dataset.casestudies === category) {
        navItem.classList.add("active");
      } else {
        navItem.classList.remove("active");
      }
    });
  }

  function compareCategory(caseStudy, category) {
    // Get the categories of the case study
    const caseStudyCategories = caseStudy.dataset.casestudy.split(",");
    // Check if the category is in the case study categories
    if (caseStudyCategories.includes(category)) {
      return true;
    }
    return false;
  }

  function checkContainerPadding(filteredCaseStudiesLength) {
    // Remove padding classes
    caseStudiesContainer.classList.remove("translate-padding-add");
    caseStudiesContainer.classList.remove("translate-padding-remove");
    // Get the remainder when the number of filtered case studies is divided by 5
    const remainder = filteredCaseStudiesLength % 5;
    // Check if the remainder is 4
    if (remainder === 4) {
      // Set padding class as fix, because the last case study is translated
      // down and would be cut off otherwise
      caseStudiesContainer.classList.add("translate-padding-add");
      return;
    }
    // Check if the remainder is 2
    if (remainder === 2) {
      // Set padding class as fix, because the last case study is translated
      // up and would there would be a gap otherwise
      caseStudiesContainer.classList.add("translate-padding-remove");
      return;
    }
  }
}

export default initializeCaseStudyOverview;
